import moment from 'moment'
import { easter as getEasterDate} from 'w3box-utils'

const constant = {
  '01-01': {
    id: 'new-years-day',
    title: 'Nowy Rok',
  },
  '01-06': {
    id: 'epiphany',
    title: 'Trzech Króli',
  },
  '05-01': {
    id: 'may-day',
    title: "Święto Pracy",
  },
  '05-03': {
    id: 'constitution-day',
    title: "Święto Konstytucji 3 Maja",
  },
  '08-15': {
    id: 'assumption',
    title: "WNMP",
  },
  '11-01': {
    id: 'all-saints',
    title: "Wszystkich Świętych",
  },
  '11-11': {
    id: 'independence',
    title: "Dzień Niepodległości",
  },
  '12-25': {
    id: 'christmas1',
    title: "Boże Narodzenie",
  },
  '12-26': {
    id: 'christmas2',
    title: "Boże Narodzenie",
  },
}

function holidaysForAllYear(year) {
  const result = []
  for(var k in constant) result.push({...constant[k], date: year + '-' + k})
  const easterDate = getEasterDate(year)
  const easter = moment(easterDate)
  result.push({
    id: 'easter1',
    title: 'Wielkanoc',
    date: easter.format('YYYY-MM-DD')
  })
  result.push({
    id: 'easter2',
    title: "Poniedziałek Wielkanocny",
    date: easter.clone().add(1, 'day').format('YYYY-MM-DD')
  })
  result.push({
    id: 'pentecost',
    title: "Zielone Świątki",
    date: easter.clone().add(49, 'day').format('YYYY-MM-DD')
  })
  result.push({
    id: 'corpus-christi',
    title: "Boże Ciało",
    date: easter.clone().add(60, 'day').format('YYYY-MM-DD')
  })
  result.sortOn('date')
  return result
}

export default (startDate, endDate) => {
  startDate = startDate ? moment(startDate) : moment().startOf('year')
  endDate = endDate ? moment(endDate) : moment().endOf('year')

  const result = []
  let year, i, y = startDate.year()
  do {
    year = holidaysForAllYear(y)
    for(i = 0; i < year.length; i++) {
      const date = moment(year[i].date)
      if(date.diff(startDate) < 0) continue
      if(date.diff(endDate) > 0) break
      result.push(year[i])
    }
    y++
  } while(i == year.length)

  return result
}